import axiosIns from '@/api/axios';

export const GET_IDP_PERIOD = (args) => {
    return axiosIns.get(`/idp-period`, args);
}
export const CREATE_IDP_PERIOD = (args) => {
    return axiosIns.post('/idp-period', args)
}

export const UPDATE_IDP_PERIOD = (args) => {
    return axiosIns.put(`/idp-period/${args.id}`, args.data)
}


